/**
 * Patient Atoms - State management for Patients
 *
 * NO LOCAL TYPES - All types come from @/isomorphic/schemas
 *
 * NOTE: All action functions have been moved to actions/patient-actions.ts
 * This file now only contains atom definitions (state)
 */

import { atom } from "jotai";
import type { Patient } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// ATOMS
// ============================================================================

/**
 * Internal atom: Workspace patients (from API)
 * Exported for use in action functions
 */
export const _apiWorkspacePatientsAtom = atom<Patient[]>([]);

export const workspacePatientsStatusAtom = atom<AtomStatus>("init");
export const workspacePatientsErrorAtom = atom<AtomError>(null);
export const currentPatientAtom = atom<Patient | null>(null);
export const currentPatientStatusAtom = atom<AtomStatus>("init");

/**
 * Public atom: Workspace patients
 */
export const workspacePatientsAtom = atom<Patient[]>((get) => {
  return get(_apiWorkspacePatientsAtom);
});
